import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SaveContractorHireHistoryMutation,  IContractorHireHistoryInput} from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';

import { ContractorHireHistoryApiService } from '../contractorhirehistory-api.service';

@Injectable({
    providedIn: 'root'
  })
  export class ContractorHireHistoryGqlService implements ContractorHireHistoryApiService {

    constructor(
      private apollo: Apollo
    ) { }

    public update(contractorHireHistoryInput: IContractorHireHistoryInput): Observable<any> {
      return this.apollo
        .mutate({
          mutation: SaveContractorHireHistoryMutation,
          variables : {
            contractorHireHistoryInput
          }
        })
        .pipe(map(result => result.data['saveContractorHireHistory'].id as string));
    }
  }
